import {AssetsService} from './assets.service';
import {BehaviorSubject, forkJoin, Observable, of, Subject} from 'rxjs';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ErrorService} from '../../shared/_services/error.service';
import {HttpClient} from '@angular/common/http';
import {Injectable, OnDestroy} from '@angular/core';
import {DateService} from './date.service';
import {CssDataModel, CssModel} from '../_models/css.model';
import {SbService} from '../../shared/_services/sb.service';
import {SoService} from '../../shared/_services/so.service';
import * as moment from 'moment';
import {AssetSelectedModel} from '../_models/asset.model';
import {DATE_FORMAT, DateModel} from '../_models/date.model';

@Injectable({
  providedIn: 'root'
})
export class CssService implements OnDestroy {

  private css$ = new BehaviorSubject<CssModel[]>([]);

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private assetsService: AssetsService,
    private dateService: DateService,
    private errorService: ErrorService,
    private httpClient: HttpClient,
    private sbService: SbService,
    private soService: SoService,
  ) {
    this.getSo();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private getSo(): void {
    this.soService.onNewSoActive()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (so) => {
          if (so === '') {
            this.callGetCss();
          }
        }
      );
  }

  private callGetCss(): void {
    const assets = this.assetsService.getSelAssets();
    const curDate = this.dateService.getNominationDate();
    if (assets?.length && curDate) {
      this.getCssHttp(assets, curDate)
        .subscribe(
          (data) => {
            if (data?.length) {
              this.newCss(data);
            }
          },
          (err) => {
            console.log(err);
            this.newCss([]);
            this.sbService.message('Something went wrong loading the data for assets: ' + err.errMessage);
          }
        );
    }
  }

  private getCssHttp(selAssets: AssetSelectedModel[], date: DateModel): Observable<any> {
    const httpRequests = [];
    for (const asset of selAssets) {
      httpRequests.push(
        this.httpClient.get(
          environment.urlWarp + '/read/css/' + asset.asset +
          '?start=' + date.date +
          '&stop=' + date.date +
          '&start=' + moment(date.date).add(date.horAsOf, 'day').format(DATE_FORMAT) +
          '&stop=' + moment(date.date).add(date.horUpTo, 'day').format(DATE_FORMAT)
        ).pipe(
          map((r: any) => {
            return {
              asset: asset.asset,
              assetLabel: asset.assetLabel,
              country: asset.country,
              cssData: r.data ? r.data.map((d) => new CssDataModel(d)) : []
            };
          }),
          catchError(this.errorService.handleError)
        )
      );
    }
    if (!httpRequests.length) {
      return of([]);
    }
    return forkJoin(httpRequests);
  }

  // ********************************************************************************************************
  // CHANGE DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // BROADCAST DATA
  // ********************************************************************************************************

  newCss(data: CssModel[]) {
    this.css$.next(data);
  }

  onNewCss(): Observable<CssModel[]> {
    return this.css$.asObservable();
  }

  getCss(): CssModel[] {
    return this.css$.getValue();
  }

}
